import script from "./ModalAddToGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalAddToGroup.vue?vue&type=script&lang=ts&setup=true"

import "./ModalAddToGroup.vue?vue&type=style&index=0&id=32bf987b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32bf987b"]])

export default __exports__